// HKDSE Chinese and English Language Extended Mock Data
// 香港中學文憑考試 中英文科目 擴展模擬數據

export const hkdseChineseEnglishExtended = [
  // ===== CHINESE LANGUAGE EXAMS =====
  
  // Chinese Language Paper 1 - Reading Comprehension
  {
    id: 16,
    name: 'HKDSE 中國語文 卷一 (閱讀理解)',
    nameEn: 'HKDSE Chinese Language Paper 1 (Reading Comprehension)',
    nameCn: 'HKDSE 中国语文 卷一 (阅读理解)',
    nameJa: 'HKDSE 中国語 第一部 (読解)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文閱讀理解、文言文理解和語文運用能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個詞語的讀音正確？",
        questionEn: "Which pronunciation is correct?",
        hasAudio: true,
        audioUrl: "/audio/chinese/pronunciation_1.mp3",
        options: ["載(zài)重", "載(zǎi)重", "載(zài)歌載舞", "記載(zài)"],
        correctAnswer: 0,
        explanation: "「載重」應讀作「zài」，表示承受重量。「載歌載舞」中的「載」讀作「zài」。",
        explanationEn: "\"載重\" should be pronounced \"zài\", meaning to bear weight.",
        difficulty: "medium",
        topic: "語音知識"
      },
      {
        id: 2,
        question: "請聽以下詩句朗讀，選出正確的韻腳：",
        questionEn: "Listen to the poem recitation and identify the rhyme:",
        hasAudio: true,
        audioUrl: "/audio/chinese/poem_recitation_1.mp3",
        options: ["平聲韻", "仄聲韻", "入聲韻", "混合韻"],
        correctAnswer: 0,
        explanation: "這首詩使用平聲韻，韻腳字都是平聲調。",
        explanationEn: "This poem uses level tone rhyme.",
        difficulty: "hard",
        topic: "詩歌韻律"
      },
      {
        id: 3,
        question: "「君子之交淡如水」中「淡」字的含義是：",
        questionEn: "What does \"淡\" mean in \"君子之交淡如水\"?",
        hasAudio: true,
        audioUrl: "/audio/chinese/idiom_explanation_1.mp3",
        options: ["清淡無味", "平淡樸素", "清澈透明", "簡單容易"],
        correctAnswer: 1,
        explanation: "「淡」在此處指平淡樸素，不追求功利，強調君子之間的友誼純潔。",
        explanationEn: "\"淡\" here means simple and pure, emphasizing the purity of friendship between gentlemen.",
        difficulty: "medium",
        topic: "成語理解"
      },
      {
        id: 4,
        question: "下列哪個句子使用了擬人修辭手法？",
        questionEn: "Which sentence uses personification?",
        hasAudio: true,
        audioUrl: "/audio/chinese/rhetoric_examples.mp3",
        options: ["春風吹綠了大地", "花兒在風中跳舞", "雨後的空氣很清新", "太陽照耀著大地"],
        correctAnswer: 1,
        explanation: "「花兒在風中跳舞」把花兒當作人來寫，賦予了人的動作，是擬人手法。",
        explanationEn: "\"Flowers dancing in the wind\" attributes human actions to flowers, which is personification.",
        difficulty: "easy",
        topic: "修辭手法"
      },
      {
        id: 5,
        question: "古文「學而時習之，不亦說乎」中「說」字應讀作：",
        questionEn: "How should \"說\" be pronounced in the classical text?",
        hasAudio: true,
        audioUrl: "/audio/chinese/classical_pronunciation.mp3",
        options: ["shuō", "yuè", "tuō", "shuì"],
        correctAnswer: 1,
        explanation: "在古文中，「說」通「悅」，讀作「yuè」，表示高興、愉快。",
        explanationEn: "In classical Chinese, \"說\" is interchangeable with \"悅\" and pronounced \"yuè\", meaning happy.",
        difficulty: "hard",
        topic: "古文字音"
      }
      // ... (25 more questions would follow)
    ]
  },

  // Chinese Language Paper 2 - Writing and Language Use
  {
    id: 17,
    name: 'HKDSE 中國語文 卷二 (寫作及語文運用)',
    nameEn: 'HKDSE Chinese Language Paper 2 (Writing and Language Use)',
    nameCn: 'HKDSE 中国语文 卷二 (写作及语文运用)',
    nameJa: 'HKDSE 中国語 第二部 (作文と語法)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文寫作技巧、語法運用和表達能力',
    modes: {
      examMode: { name: '考試模式', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "下列哪個句子的標點符號使用正確？",
        questionEn: "Which sentence uses punctuation correctly?",
        hasAudio: true,
        audioUrl: "/audio/chinese/punctuation_examples.mp3",
        options: [
          "他問：「你今天去哪裡？」",
          "他問「你今天去哪裡？」",
          "他問：你今天去哪裡？",
          "他問，「你今天去哪裡？」"
        ],
        correctAnswer: 0,
        explanation: "直接引語前應用冒號，引語用引號包圍，問號放在引號內。",
        explanationEn: "Direct speech should be preceded by a colon, enclosed in quotation marks, with the question mark inside.",
        difficulty: "medium",
        topic: "標點符號"
      }
      // ... (29 more questions would follow)
    ]
  },

  // ===== ENGLISH LANGUAGE EXAMS =====
  
  // English Language Paper 1 - Reading
  {
    id: 18,
    name: 'HKDSE English Language Paper 1 (Reading)',
    nameEn: 'HKDSE English Language Paper 1 (Reading)',
    nameCn: 'HKDSE 英语 卷一 (阅读)',
    nameJa: 'HKDSE 英語 第一部 (読解)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English reading comprehension, vocabulary and language analysis skills',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the passage and answer: What is the main topic discussed?",
        questionEn: "Listen to the passage and answer: What is the main topic discussed?",
        hasAudio: true,
        audioUrl: "/audio/english/reading_passage_1.mp3",
        options: [
          "Climate change effects",
          "Renewable energy sources", 
          "Environmental conservation",
          "Global warming solutions"
        ],
        correctAnswer: 2,
        explanation: "The passage primarily discusses various methods of environmental conservation and their importance.",
        explanationEn: "The passage primarily discusses various methods of environmental conservation and their importance.",
        difficulty: "medium",
        topic: "Reading Comprehension"
      },
      {
        id: 2,
        question: "Which word best replaces 'ubiquitous' in the sentence: 'Smartphones have become ubiquitous in modern society'?",
        questionEn: "Which word best replaces 'ubiquitous' in the sentence: 'Smartphones have become ubiquitous in modern society'?",
        hasAudio: true,
        audioUrl: "/audio/english/vocabulary_context.mp3",
        options: ["rare", "expensive", "everywhere", "useful"],
        correctAnswer: 2,
        explanation: "'Ubiquitous' means present, appearing, or found everywhere. 'Everywhere' is the best synonym.",
        explanationEn: "'Ubiquitous' means present, appearing, or found everywhere. 'Everywhere' is the best synonym.",
        difficulty: "medium",
        topic: "Vocabulary"
      }
      // ... (28 more questions would follow)
    ]
  },

  // English Language Paper 2 - Writing
  {
    id: 19,
    name: 'HKDSE English Language Paper 2 (Writing)',
    nameEn: 'HKDSE English Language Paper 2 (Writing)',
    nameCn: 'HKDSE 英语 卷二 (写作)',
    nameJa: 'HKDSE 英語 第二部 (作文)',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English writing skills, grammar usage and text organization',
    modes: {
      examMode: { name: 'Exam Mode', timeLimit: 150, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: 'Study Mode', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: 'Pre-test Mode', timeLimit: 150, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "Which sentence demonstrates correct parallel structure?",
        questionEn: "Which sentence demonstrates correct parallel structure?",
        hasAudio: true,
        audioUrl: "/audio/english/grammar_parallel.mp3",
        options: [
          "She likes reading, writing, and to paint.",
          "She likes reading, writing, and painting.",
          "She likes to read, writing, and painting.",
          "She likes read, write, and paint."
        ],
        correctAnswer: 1,
        explanation: "Parallel structure requires all items in a series to have the same grammatical form. 'Reading, writing, and painting' are all gerunds.",
        explanationEn: "Parallel structure requires all items in a series to have the same grammatical form. 'Reading, writing, and painting' are all gerunds.",
        difficulty: "medium",
        topic: "Grammar"
      }
      // ... (29 more questions would follow)
    ]
  }
];

// Note: This file contains sample questions for demonstration. 
// In a complete implementation, each exam would have all 30 questions fully developed. 